import { onError } from "@apollo/client/link/error";
//link to log details of query and fetch trace id from response header when error occurs
export const logginglink = () => onError(({ graphQLErrors, networkError, operation }) => {
    try {
        const operationName = operation.operationName;
        const context = operation.getContext();
        let traceId;
        if (context.response.headers) {
            traceId = context.response.headers.get("trace-id");
        }
        if ((graphQLErrors || networkError) && traceId) {
            console.log(`Error in operation: ${operationName}, Trace ID: ${traceId}`);
        }
        else if ((graphQLErrors || networkError) && !traceId) {
            console.log(`Unable to fetch traceId for error in operation: ${operationName}`);
        }
    }
    catch (error) {
        console.log("Error logging details of failing operation and related trace-id:", error);
    }
});
//# sourceMappingURL=logging.js.map